export default function HowItWorks({ t }) {
  return (
    <section id="how" data-testid="section-how" className="py-20 md:py-28 tk-section-anchor">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center mb-14">
          <span className="tk-eyebrow">
            <span className="tk-divider" />
            {t.how.kicker}
            <span className="tk-divider" />
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl mt-5 text-[var(--ink)]">
            {t.how.title}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.how.steps.map((step, index) => (
            <article
              key={step.n}
              data-testid={`how-step-${index + 1}`}
              className="tk-card p-7 relative"
            >
              <div className="flex justify-center">
                <span className="font-serif italic text-5xl text-[var(--burgundy)]">
                  {step.n}
                </span>
              </div>
              <h3 className="font-serif text-2xl mt-5 text-[var(--ink)]">{step.title}</h3>
              <p className="text-sm text-[var(--ink-soft)] mt-3 leading-relaxed">
                {step.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
